import Vue from 'vue'
import LoadingComponent from '@/components/Loading.vue'

let instance

function createInstance() {
  // 创建 Loading 组件实例
  const LoadingConstructor = Vue.extend(LoadingComponent)
  instance = new LoadingConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(instance.$el)
}

export default {
  show() {
    if (!instance) {
      createInstance()
    }
    instance.$el.style.display = 'flex'
  },
  hide() {
    if (instance) {
      instance.$el.style.display = 'none'
    }
  }
}
